module.exports = __webpack_public_path__ + "static/img/order-coupon-title.9a5768e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order-coupon-title.png
// module id = 340
// module chunks = 7